"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFileData = void 0;
const ramda_1 = require("ramda");
const proposal_1 = require("./client/proposal");
const constants_1 = require("./client/proposal/hooks/constants");
const attributes_1 = require("./constants/attributes");
const upload_file_options_1 = require("./models/upload-file-options");
const utils_1 = require("./utils");
const parseFileRow = ({ row, columnPairs, }) => {
    var _a, _b;
    const parsedAttributes = {};
    const parsedMeasures = {};
    const parsedCategories = [];
    for (const [attribute, columnWithUnit] of columnPairs) {
        const isMeasure = !!columnWithUnit;
        const values = [].concat(row[attribute]);
        if (values.length) {
            for (const value of values) {
                if (isMeasure) {
                    const unit = row[columnWithUnit] || columnWithUnit;
                    if (value && unit) {
                        const parsedValue = Number(value);
                        if (!Number.isNaN(parsedValue)) {
                            // if the measure unit in the row is empty its value will be taken from the column name
                            parsedMeasures[attribute] = [...(_a = parsedMeasures[attribute]) !== null && _a !== void 0 ? _a : [], { unit, value: parsedValue }];
                        }
                    }
                }
                else if ((0, utils_1.areEqualCaseInsensitive)(attribute, attributes_1.CATEGORY_ATTRIBUTE_NAME)) {
                    if (value) {
                        parsedCategories.push(value);
                    }
                }
                else {
                    parsedAttributes[attribute] = [...(_b = parsedAttributes[attribute]) !== null && _b !== void 0 ? _b : [], value];
                }
            }
        }
    }
    return { parsedAttributes, parsedMeasures, parsedCategories };
};
const parseFileData = ({ data, columnsOrder, mode, isMeasuresEnabled, }) => {
    const records = [];
    const [idColumnName, ...attributeNames] = columnsOrder;
    const columnPairs = (0, ramda_1.splitEvery)(isMeasuresEnabled ? 2 : 1, attributeNames);
    data.forEach((row) => {
        // treat the first column as an id column
        const productId = row[idColumnName];
        const { parsedAttributes, parsedMeasures, parsedCategories } = parseFileRow({ row, columnPairs });
        const operationType = mode === upload_file_options_1.UpdateDataModes.Replace
            ? proposal_1.BulkAssertionOperationTypes.Replace
            : proposal_1.BulkAssertionOperationTypes.Merge;
        const categories = !(0, ramda_1.isEmpty)(parsedCategories)
            ? (0, constants_1.getProductAssertionBatchCategoriesInput)(parsedCategories[0])
            : null;
        const labels = !(0, ramda_1.isEmpty)(parsedAttributes)
            ? Object.entries(parsedAttributes).reduce((acc, [attribute, values]) => [
                ...acc,
                ...(0, proposal_1.getProductAssertionBatchLabelsInput)(operationType, attribute, values),
            ], [])
            : null;
        const measures = !(0, ramda_1.isEmpty)(parsedMeasures)
            ? Object.entries(parsedMeasures).reduce((acc, [attribute, valueItems]) => [
                ...acc,
                ...(0, proposal_1.getProductAssertionBatchMeasuresInput)(operationType, attribute, valueItems),
            ], [])
            : null;
        if ((labels === null || labels === void 0 ? void 0 : labels.length) || (measures === null || measures === void 0 ? void 0 : measures.length) || (categories === null || categories === void 0 ? void 0 : categories.length)) {
            records.push(Object.assign(Object.assign(Object.assign({ externalId: productId }, labels && { labels }), measures && { measures }), categories && { categories }));
        }
    });
    return records;
};
exports.parseFileData = parseFileData;
